import HeroSection from "./WhatsappApiService/HeroSection";
import PlatformSection from "./WhatsappApiService/PlatformSection";
import FeaturesSection from "./WhatsappApiService/FeaturesSection";
import FooterSection from "./WhatsappApiService/FooterSection";

export default function WhatsappApiService() {
  return (
    <main className="bg-black text-white overflow-hidden">
      <HeroSection />
      <PlatformSection />
      <FeaturesSection />
      <FooterSection />
    </main>
  );
}